import { Component } from '@angular/core';
import { NgxSpinnerService } from 'ngx-spinner';
import { AppService } from './app.service';
import { environment } from '../environments/environment';

@Component({
  selector: 'app-root',
  styleUrls: ['./app.component.css'],
  template: `<nav class="navbar tantum-header">
  <div class="container-fluid">
    <div class="navbar-header">
      <div class="header-left">
        <a class="tantum-brand" href="/">
          <img src="assets/TantumIdent.svg" alt="TantumPay" class="tantum-logo">
        </a>
      </div>
      <div class="header-right">
        <a class="logout" (click)="logout()">Logout</a>
      </div>
    </div>
  </div>
</nav>
<router-outlet></router-outlet>
<footer class="tantum-footer">
  <div class="container-fluid">
    <div class="footer-content">
      <div class="footer-links">
        <a href="https://tantumpay.com/en/imprint/" class="footer-link" target="_blank">Imprint</a>
        <a href="https://tantumpay.com/en/privacy-policy/" class="footer-link" target="_blank">Privacy Policy</a>
        <a href="https://tantumpay.com/en/terms-and-conditions/" class="footer-link" target="_blank">Terms and Conditions</a>
      </div>
      <div class="footer-copyright">
        © 2025 Tantum AG, NFC-Ident Flow. All rights reserved.
      </div>
    </div>
  </div>
</footer>`
})

export class AppComponent {

  constructor(
    private _service: AppService) {
    this.loadRecaptchaScript();
  }

  /**
   * Carica dinamicamente lo script reCAPTCHA usando la chiave dalle environment variables
   */
  private loadRecaptchaScript(): void {
    const script = document.createElement('script');
    script.src = `https://www.google.com/recaptcha/enterprise.js?render=${environment.captcha_key}`;
    script.async = true;
    script.defer = true;
    document.head.appendChild(script);
  }

  logout() {
    this._service.logout();
  }
}